import React, { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../Store";
import { UndefinedOptions } from "..";
import { Graph_QL, useSystem } from "../../../Services";
import { SelectFieldOption_Values } from "../../../Definitions";

export const useSystemOptions = (includeUndefinedOption?: UndefinedOptions) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getSystemsInfo, data: systemsState } = useSystem(connection);

  useEffect(() => {
    getSystemsInfo({ fetchAmount: 500 });
  }, []);

  const systemOptions: SelectFieldOption_Values[] = useMemo(() => {
    if (systemsState && systemsState[domain]) {
      const systems = systemsState[domain].data.map(system => ({
        label: system.name,
        id: system.system_id
      }))

      if (includeUndefinedOption === UndefinedOptions.undefined) {
        return [{ label: "no system", id: null }, ...systems];
      } else if (includeUndefinedOption === UndefinedOptions.nan) {
        return [{ label: "no system", id: NaN }, ...systems];
      }

      return systems;
    }
    return includeUndefinedOption === UndefinedOptions.undefined ? [{ label: "No system", id: null }] : includeUndefinedOption === UndefinedOptions.nan ? [{ label: "No system", id: NaN }] : [];
  },[domain, includeUndefinedOption, systemsState])

  return systemOptions;
};
